import { Component, Input } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { EstatusJSON } from '../../../../shared/models/EstatusJSON';
import { AlarmDTO } from '../../models/AlarmDTO';
import { ActiveAlarmsPopupComponent } from '../active-alarms-popup/active-alarms-popup.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/map-features/sections/geofences-section/services/Geofences.service';
import { ConfirmDialogService } from 'src/app/features/ui/atoms/dialogs/confirm-dialog/services/Confirm-Dialog.service';
import { MessageDialogService } from 'src/app/features/ui/atoms/dialogs/message-dialog/services/message-dialog.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { AlarmService } from '../../services/Alarm.service';

import { environment } from "src/environments/environment";

@Component({
  selector: 'alarm-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.css']
})
export class ActionsComponent {

  @Input() alarmData: AlarmDTO;
  @Input() canBeLocked: boolean = false;
  @Input() isLocked: boolean = false;

  isLoading: boolean = false;

  suscription_getGeofence: Subscription;
  suscription_delete: Subscription;
  suscription_confirmDialogService: Subscription;
  suscription_createBlokingRequest: Subscription;
  suscription_deactivateAlarm: Subscription;

  constructor(
    private alarmService: AlarmService,
    private notifyService: SwalNotificationService,
    private geofenceService: GeofencesService,
    private confirmDialogService: ConfirmDialogService,
    private citronellaActionsService: CitronellaActionsService,
    private messageDialogService: MessageDialogService,
    public dialogRef: MatDialogRef<ActiveAlarmsPopupComponent>,
  ) { }

  ngOnDestroy(): void {
    if(this.suscription_delete)
      this.suscription_delete.unsubscribe();
    if(this.suscription_getGeofence)
      this.suscription_getGeofence.unsubscribe();
    if(this.suscription_confirmDialogService)
      this.suscription_confirmDialogService.unsubscribe();
    if(this.suscription_createBlokingRequest)
      this.suscription_createBlokingRequest.unsubscribe();
    if(this.suscription_deactivateAlarm)
      this.suscription_deactivateAlarm.unsubscribe();
  }


  DeactivateAlarm(){
    if(!environment.production) console.log("Desactivar alarma", this.alarmData);
    this.isLoading = true;
    this.notifyService.confirmMessage("Desactivar", "¿Deseas desactivar la alarma?").then((result) => {
      if (result.value) {
        this.suscription_deactivateAlarm = this.alarmService.DeactivateAlarms(this.alarmData.id).subscribe({
          next: (alarmData) => {
            if(alarmData.isSuccess){
              this.notifyService.MessageSuccessful("Alarma desactivada correctamente", "exito");
              this.isLoading = false;
              this.dialogRef.close(true);
            } else {
              Sentry.captureMessage('Actions.DeactivateAlarm: isSuccess false', { level: 'warning', extra: { response: alarmData } });
            }
            this.isLoading = false;
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error al desactivar alarma', error);
            this.notifyService.MessageError("Problema al desactivar la alarma");
            this.isLoading = false;
          }
        });
      }else{
        this.isLoading = false;
      }
    });
  }

  DeactivateGeofence(){
    this.isLoading = true;
    this.suscription_getGeofence = this.geofenceService.get(this.alarmData.idGeofence).subscribe({
      next: (alarmData) => {
        if(alarmData.isSuccess){
          var identifiers = alarmData.result.identifiers.join(',');
          var resp = this.notifyService.confirmMessage("Desactivar","¿Seguro que desea desactivar esta geocerca?, tiene los siguienetes activos asignados: "+ identifiers);
          resp.then((result) =>{
             if(result.value)
             {
                this.suscription_delete = this.geofenceService.Deactivate(this.alarmData.idGeofence).subscribe({
                  next: (alarmData) => {
                    if(alarmData.isSuccess == true){
                      this.notifyService.MessageSuccessful("Desactivado","Geocerca desactivada exitosamente");
                      this.DeactivateAlarm();
                    }else{
                      this.notifyService.MessageError("Problema al desactivar la geocerca");
                      Sentry.captureMessage('Actions.DeactivateGeofence.Deactivate: isSuccess false', { level: 'warning', extra: { response: alarmData } });
                    }
                    this.isLoading = false;
                  },
                  error: (error) => {
                    // TODO marca para complete despues
                    console.error('Error al desactivar geocerca', error);
                    this.notifyService.MessageError("Problema al desactivar la geocerca");
                    this.isLoading = false;
                  }
                });
              }else{
                this.isLoading = false;
              }
           }); 
        }else{
          this.isLoading = false;
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener geocerca', error);
        this.isLoading = false;
      }
    });
  }

  UnassignFromGeofence(){
    this.isLoading = true;
    var resp = this.notifyService.confirmMessage("Desasignar","¿Seguro que desea desasignar el auto"+ this.alarmData.identifier +"de la geocerca?");
    resp.then((result) =>{
      if(result.value)
      {
         this.suscription_delete = this.geofenceService.UnassignIdentifier(this.alarmData.idGeofence, this.alarmData.identifier).subscribe({
           next: (alarmData) => {
             if(alarmData.isSuccess == true){
               this.notifyService.MessageSuccessful("Desasignado","Activo desasignada exitosamente");
               this.DeactivateAlarm();
             }else{
               this.notifyService.MessageError("Problema al desasignar de la geocerca");
               Sentry.captureMessage('Actions.UnassignFromGeofence: isSuccess false', { level: 'warning', extra: { response: alarmData } });
             }
             this.isLoading = false;
           },
           error: (error) => {
             // TODO marca para complete despues
             console.error('Error al desasignar identificador de geocerca', error);
             this.notifyService.MessageError("Problema al desasignar de la geocerca");
             this.isLoading = false;
           }
         });

       }else{
        this.isLoading = false;
       }
    }); 
  }

  DeleteValetParking(){
    this.isLoading = true;
    this.notifyService.confirmMessage("Apagar", "Seguro que quieres desactivar el valet parking?").then((result) => {
      if (result.value) {
        this.suscription_delete = this.geofenceService.FullDelete(this.alarmData.idGeofence).subscribe({
          next: (alarmData) => {
            if(alarmData.isSuccess == true){
              this.notifyService.MessageSuccessful("Apagado","Valet Parking se ha desactivado exitosamente");
              this.DeactivateAlarm();
            }else{
              this.notifyService.MessageError("Problema al desactivar el Valet Parking");
              Sentry.captureMessage('Actions.DeleteValetParking: isSuccess false', { level: 'warning', extra: { response: alarmData } });
            }
            this.isLoading = false;
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error al eliminar Valet Parking', error);
            this.notifyService.MessageError("Problema al desactivar el Valet Parking");
            this.isLoading = false;
          }
        });
      }else{
        this.isLoading = false;
      }
    });
  }

  BlockActive() {
    this.isLoading = true;
    const title = `Solicitud de bloqueo`;
    const message = `¿Desea realizar una solicitud de bloqueo para el activo '${this.alarmData.identifier}'?`;
    
    if (!this.canBeLocked) {
      this.messageDialogService.show(title, "El activo no puede ser bloqueado o desbloqueado");
      this.isLoading = false;
      return;
    }

    if (this.isLocked) {
      this.messageDialogService.show(title, "El activo ya se encuentra bloqueado");
      this.isLoading = false;
      return;
    }

    this.suscription_confirmDialogService = this.confirmDialogService
      .show(title, message)
      .subscribe({
        next: (result) => {
          if (result) {
            this.suscription_createBlokingRequest = this.citronellaActionsService
              .createBlokingRequest(this.alarmData.identifier)
              .subscribe({
                next: (alarmData: EstatusJSON) => {
                  if(alarmData != null){
                    this.messageDialogService.show(title, alarmData.message);
                    this.isLoading = false;
                  }
                  else{
                    Sentry.captureMessage('Actions.DeactivateGeofence.get: isSuccess false', { level: 'warning', extra: { response: alarmData } });
                    this.isLoading = false;
                  }
                },
                error: (error) => {
                  // TODO marca para complete despues
                  console.error('Error al crear solicitud de bloqueo', error);
                  Sentry.captureMessage('Actions.DeactivateGeofence.get: error', { level: 'warning', extra: { response: error } });
                  this.isLoading = false;
                }
              });
          }else{
            this.isLoading = false;
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error en diálogo de confirmación de bloqueo', error);
          this.isLoading = false;
        }
      });
  }

  UnblockActive() {
    this.isLoading = true;
    const title = `Solicitud de bloqueo`;
    const message = `¿Desea realizar una solicitud de bloqueo para el activo '${this.alarmData.identifier}'?`;
    
    if (!this.canBeLocked) {
      this.messageDialogService.show(title, "El activo no puede ser bloqueado o desbloqueado");
      this.isLoading = false;
      return;
    }

    if (!this.isLocked) {
      this.messageDialogService.show(title, "El activo no se encuentra bloqueado");
      this.isLoading = false;
      return;
    }

    this.suscription_confirmDialogService = this.confirmDialogService
      .show(title, message)
      .subscribe({
        next: (result) => {
          if (result) {
            this.suscription_createBlokingRequest = this.citronellaActionsService
              .createBlokingRequest(this.alarmData.identifier)
              .subscribe({
                next: (alarmData: EstatusJSON) => {
                  this.messageDialogService.show(title, alarmData.message);
                  this.isLoading = false;
                },
                error: (error) => {
                  console.error('Error al crear solicitud de desbloqueo', error);
                  this.isLoading = false;
                }
              });
          }else{
            this.isLoading = false;
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error en dialogo de confirmación de desbloqueo', error);
          this.isLoading = false;
        }
      });
  }

}
